<template>
    <ClientOnly>
        <BaseSidebar>
            <TheNav />
        </BaseSidebar>
    </ClientOnly>
</template>
